import { capitalize } from 'lib/string_utils';

/**
 * Calculates the remaining available ticket types after booker ticket selection
 * @param {Array} units <description>
 * @param {String} selectedTicket <description>
 * @return {Array}
 */
export const calculateRemainingTickets = (units, selectedTicket) => {
  const additionalTicketTypes = [];
  // Should only account for units with at least one ticket
  const ticketedUnits = units.filter((unit) => unit.count > 0);

  // Add each ticket type to array
  ticketedUnits.forEach((unit) => {
    for (let i = 0; i < unit.count; i++) {
      additionalTicketTypes.push({
        unitTypeId: unit.id,
        unitTypeName: unit.noun_singular.toLowerCase(),
      });
    }
  });

  if (selectedTicket == null) {
    return additionalTicketTypes;
  }

  // Remove selected ticket from array
  const index = additionalTicketTypes.findIndex(
    ({ unitTypeName }) => unitTypeName === selectedTicket.toLowerCase()
  );
  if (index > -1) {
    additionalTicketTypes.splice(index, 1);
  }
  return additionalTicketTypes;
};

/**
 * Formats the available ticket types for Select component
 * @param {Array} units <description>
 * @return {Array}
 */
export const formatTicketTypes = (units) => {
  return units
    .filter((unit) => unit.count > 0)
    .map((unit) => {
      return {
        label: capitalize(unit.noun_singular),
        value: capitalize(unit.noun_singular),
      };
    });
};

/**
 * Format bookerGuestName for GuestInformation component
 */
export const formatBookerGuestName = ({ firstName, lastName }) => {
  if (firstName != null && lastName != null) {
    return `${firstName} ${lastName}`;
  }
  return '';
};

/**
 * Formats additional guests for an affiliate booking
 * @param {Array} affiliateGuests <description>
 * @return {Array}
 */
export const formatAffiliateGuests = (affiliateGuests) => {
  let affiliateGuestArray = [];

  if (affiliateGuests?.length > 0) {
    affiliateGuestArray = affiliateGuests.map((guest, index) => {
      return {
        first_name: '',
        last_name: '',
        full_name: '',
        position: index - 1,
        unit_type_id: guest.unitTypeId,
      };
    });
    // Remove first guest to account for "booker"
    affiliateGuestArray.shift();
  }

  return affiliateGuestArray;
};

/**
 * Returns list of formatted affiliate guests for form submission
 * @param {Array} Units<description>
 * @return {Array}
 */
export const getFormattedAffiliateGuests = (units) => {
  const affiliateGuests = calculateRemainingTickets(units, null);
  return formatAffiliateGuests(affiliateGuests);
};
